<script>
    import {Gtag} from '../../mixins/ga'

    export default {
        mixins: [Gtag],
        props: ['data', 'course'],
        data() {
            return {
                confirmText: '',
                effect: false,
                collapseClass: {},
            }
        },
        mounted() {
            if (! $(this.$refs.item).find('.collapse').is(':visible')) {
                this.$set(this, 'effect', true)
            } else {
                this.$set(this, 'effect', false)
            }

            window.resize = function(e) {
                this.onResize()
            }
        },
        methods: {
            addToCart(buyable, type, course = null) {
                var self = this;

                axios({
                    method: 'post',
                    url: 'addToCart',
                    data: {
                        buyable: buyable,
                        type: type,
                        course
                    }
                }).then((response) => {              
                    this.sendGaEvent(
                        'Acquista',
                        'Corsi',
                        '#aggiungi-carrello-corso'
                    )
                      
                    window.alerts.success('Elemento aggiunto al carrello');
                    self.federations = response.data.federations;

                    window.location = '/carts'
                }).catch((error) => {
                    self.message = 'Error';
                });
            },
            onResize() {
                if (! $(this.$refs.item).find('.collapse').is(':visible')) {
                    this.$set(this, 'effect', true)
                } else {
                    this.$set(this, 'effect', false)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/CourseBuyableItem.vue